import useGreeksWebsocketDataStore from '../../Store/GreeksWebsocketDataStore';

export const deltaPairGetter = function (PineJS) {
  return Promise.resolve([
    {
      name: 'SPX Delta Pair',
      metainfo: {
        metainfoVersion: 53,
        id: "SPX_Delta_Pair@tv-basicstudies-1",
        description: "SPX Delta Pair",
        shortDescription: "SPX Delta Pair",
        linkedToSeries: true,
        is_price_study: false,
        format: { type: "price" },
        plots: [
          {
            id: "calls_delta",
            type: "line",
            title: "Calls Delta"
          },
          {
            id: "puts_delta",
            type: "line",
            title: "Puts Delta"
          },
          {
            id: "zero_line",
            type: "line",
            title: "Zero Line"
          }
        ],
        defaults: {
          styles: {
            calls_delta: {
              linestyle: 0,
              linewidth: 1,
              plottype: 0,  // Line plot
              trackPrice: false,
              transparency: 0,
              visible: true,
              color: "#f3d40e"  // Green for calls
            },
            puts_delta: {
              linestyle: 0,
              linewidth: 1,
              plottype: 0,  // Line plot
              trackPrice: false,
              transparency: 0,
              visible: true,
              color: "rgba(36,212,255,0.82)"  // Red for puts
            },
            zero_line: {
              linestyle: 0,
              linewidth: 1,
              color: "#ffffff",  // White zero line
              visible: true
            }
          },
          precision: 2,
          inputs: {}
        },
        styles: {
          calls_delta: { title: "Calls Delta" },
          puts_delta: { title: "Puts Delta" },
          zero_line: { title: "Zero Line" }
        },
        inputs: []
      },
      constructor: function () {
        this._debugMode = true;

        this.init = function (ctx) {
          this._context = ctx;
        };

        this.main = function (ctx) {
          try {
            // Get latest data from store on each main() call
            const { greekExposures } = useGreeksWebsocketDataStore.getState();
            const spxExposures = greekExposures.spx;


            if (!spxExposures?.length) {
              if (this._debugMode) {
                // console.log('[deltaPairGetter] No greek exposures data');
              }
              return [null, null, null];
            }

            const time = ctx.symbol.time;
            if (!time || isNaN(time)) {
              if (this._debugMode) {
                // console.log('[deltaPairGetter] Invalid symbol time:', time);
              }
              return [null, null, null];
            }

            const timeInSec = Math.floor(time / 1000);

            // Filter and sort delta exposures
            const deltaExposures = spxExposures
              .filter(exp => exp.greek_type === 'delta')
              .sort((a, b) => a.timestamp - b.timestamp);

            if (!deltaExposures.length) {
              return [null, null, null];
            }

            // Find the closest data point to the requested time
            let closestExp = deltaExposures[0];
            let minDiff = Math.abs(closestExp.timestamp - timeInSec);

            for (const exp of deltaExposures) {
              const diff = Math.abs(exp.timestamp - timeInSec);

              if (diff < minDiff) {
                minDiff = diff;
                closestExp = exp;
              }
            }

            const callsValue = parseFloat(closestExp.calls_total) || 0;
            const putsValue = parseFloat(closestExp.puts_total) || 0;

            // if (this._debugMode) {
            //   console.log(`[deltaPairGetter] Chart time: ${new Date(timeInSec * 1000).toLocaleString('en-US', {
            //     timeZone: 'America/New_York'
            //   })}, Using values - Calls: ${callsValue}, Puts: ${putsValue} from time: ${new Date(closestExp.timestamp).toLocaleString('en-US', {
            //     timeZone: 'America/New_York'
            //   })}`);
            // }

            return [callsValue, putsValue, 0];  // Return calls, puts, and zero line values
          } catch (err) {
            // console.error('[deltaPairGetter] Error in main:', err);
            return [null, null, null];
          }
        };

        this.destroy = function() {
          // No cleanup needed since we're not using subscriptions
        };
      }
    }
  ]);
};